import ProductListSlider from "./components/Sliders/ProductListSlider";
import SalesSlider from "./components/Sliders/SalesSlider";
import VideosSlider from "./components/Sliders/VideosSlider";

document.addEventListener("DOMContentLoaded", async (e) => {
    new SalesSlider().init();
    new VideosSlider().init();
    new ProductListSlider().init();
});